<template>
  <div v-if="foundDealers.length > 0" class="dm-results">
    <slot
      name="results"
      :foundDealers="foundDealers"
      :selectDealer="selectDealer"
      :getMarker="getMarker"
      :translations="translations"
    >
      <div class="dm-results__items">
        <div
          v-for="dealer in foundDealers"
          :key="dealer.Id"
          class="dm-result"
          @click="selectDealer(dealer)"
        >
          <div class="dm-result__distance">
            <img :src="getMarker(dealer.Categories)" width="30" height="37" />
            <span
              v-if="typeof dealer.Distance === 'number' && dealer.Distance >= 0"
            >
              {{ dealer.Distance }} {{ translations.Kilometers }}
            </span>
          </div>
          <div class="dm-result__info">
            <strong>{{ dealer.Name }}</strong>
            <br />
            {{ dealer.Address }}
            <br />
            {{ dealer.Postalcode }} {{ dealer.City }}
          </div>
        </div>
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'ComponentResults',
  props: {
    foundDealers: Array,
    activeDealer: Object,
    mapOptions: Object,
    assetsFolder: String,
    translations: Object
  },
  data() {
    return {
      active: this.activeDealer
    };
  },
  methods: {
    selectDealer(d) {
      this.active = d;
      this.$emit('update:activeDealer', this.active);
      this.$emit('update:mapOptions', {
        // eslint-disable-next-line no-undef
        position: new google.maps.LatLng(d.Position.Lat, d.Position.Lng)
      });
    },
    getMarker(name) {
      if (name && name[0] && name[0].CodeName) {
        return this.assetsFolder + '/marker_' + name[0].CodeName + '.png';
      } else {
        return this.assetsFolder + '/marker.png';
      }
    }
  }
};
</script>

<style lang="scss">
.dm-results {
  flex: 1 1 auto;
  overflow: auto;
  background: #fff;

  @media (max-width: 991.98px) {
    max-height: 500px;
  }

  &__items {
    border-bottom: 1px solid #dddddd;
  }

  &__item {
    border-bottom: 1px solid #dddddd;
    padding: 20px;

    &:hover,
    &:focus {
      background: #fbfbfb;
      cursor: pointer;
    }

    &:last-child {
      border: 0;
    }
  }
}
.dm-result {
  display: flex;
  border-bottom: 1px solid #dddddd;
  padding: 20px 20px 20px 10px;

  &:hover,
  &:focus {
    background: #fbfbfb;
    cursor: pointer;
  }

  &:last-child {
    border: 0;
  }

  &__distance {
    flex: 0 0 auto;
    min-width: 80px;
    text-align: center;
    display: flex;
    flex-direction: column;

    svg,
    img {
      margin: 0 auto 10px;
    }
  }

  &__info {
    padding-left: 10px;
  }
}
</style>
